import { CTA, styled } from "@volkswagen-onehub/components-core";

export const StyledDeactiveAccountCTA = styled(CTA)`
    color: ${({ theme }) => theme.colors.signal.error};

    :hover {
        color: ${({ theme }) => theme.colors.wishlist.background.hover};
    }
`;